export const LIGHT_CHAT_CSS_VARS = {
    '--chat-l-brightest': '0.98',
    '--chat-l-bg': '0.87',
    '--chat-l-surface': '0.94',
    '--chat-l-code': '0.85',
    '--chat-l-accent': '0.42',
    '--chat-l-text': '0.25',
    '--chat-l-text-faint': '0.55',
    '--chat-l-text-muted': '0.50',
    '--chat-l-text-subtle': '0.45',
    '--chat-l-text-normal': '0.35',
    '--chat-l-text-content': '0.28',
    '--chat-c-muted': '0.015',
    '--chat-c-subtle': '0.03',
    '--chat-c-accent': '0.15',
};
export const DARK_CHAT_CSS_VARS = {
    '--chat-l-brightest': '0.02',
    '--chat-l-bg': '0.25',
    '--chat-l-surface': '0.27',
    '--chat-l-code': '0.20',
    '--chat-l-accent': '0.40',
    '--chat-l-text': '0.95',
    '--chat-l-text-faint': '0.55',
    '--chat-l-text-muted': '0.62',
    '--chat-l-text-subtle': '0.70',
    '--chat-l-text-normal': '0.82',
    '--chat-l-text-content': '0.92',
    '--chat-c-muted': '0.025',
    '--chat-c-subtle': '0.05',
    '--chat-c-accent': '0.18',
};
export const getChatCSSVars = (hue, darkMode) => {
    const themeVars = darkMode ? DARK_CHAT_CSS_VARS : LIGHT_CHAT_CSS_VARS;
    const vars = {
        '--chat-hue': String(hue ?? 145),
        ...themeVars,
    };
    return vars;
};
//# sourceMappingURL=styles.js.map